import { useCallback, useState } from 'react';

export function useToggle(initialValue: boolean) {
  const [value, setValue] = useState(initialValue);

  const toggleValue = useCallback((callback?: (newValue: boolean) => void) => {
    setValue((prevValue) => {
      const newValue = !prevValue;
      callback?.(newValue);

      return newValue;
    });
  }, []);

  return [value, toggleValue] as const;
}
